// @ts-strict-ignore
import { ReactNode, useEffect, useRef } from 'react';

import { Box } from 'components/Box';
import { Icon } from 'components/Icon';
import { Status, StatusLabel } from 'components/StatusLabel';
import { VisuallyHidden } from 'components/VisuallyHidden';

import { CloseButton } from './UserNotification.styled';

type Props = {
  status?: Status;
  children: ReactNode;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dismiss?: (...args: Array<any>) => any;
};

export function UserNotification({
  status,
  children,
  dismiss,
  ...props
}: Props) {
  const ref = useRef(null);
  // Using a ref here, because we want to ensure this event handler
  // cannot fire more than once, and the `once` property is more reliable than
  // using state or a functional solution. We only want to run this when
  // the ref is ready, so no deps in the effect

  useEffect(() => {
    if (ref && ref.current && dismiss) {
      ref.current.addEventListener('click', dismiss, {
        once: true,
      });
    }
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, []);

  return (
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Box position="relative" {...props}>
      {status && <StatusLabel status={status} />}
      <Box lineHeight={1.375} maxWidth="95%">
        {children}
      </Box>
      {dismiss && (
        <Box position="absolute" top={0} right={0}>
          <div ref={ref}>
            <CloseButton>
              <Icon initialColorName="battleshipGrey" name="close" size={12} />
              <VisuallyHidden>{getText('Clear notification')}</VisuallyHidden>
            </CloseButton>
          </div>
        </Box>
      )}
    </Box>
  );
}
